export default class CreateHotSpotModel {
    assetId = null;
    scanId = null;
    transform = null;
    anomalyIds = [];
    inspectionAreaId = null;

    constructor(assetId, positionX, positionY, positionZ, anomalyIds = [], inspectionAreaId = null, scanId = null){
        this.assetId = assetId;
        this.scanId = scanId;
        this.anomalyIds = anomalyIds;
        this.inspectionAreaId = inspectionAreaId;

        this.transform = {
            position: {
                x: positionX || 0,
                y: positionY || 0,
                z: positionZ || 0,
              },
              scale: {
                x: 2,
                y: 2,
                z: 2,
                order: "XYZ",
                isEuler: false
              },
              rotation: {
                x: 0,
                y: 0,
                z: 0,
              },
        };
    }
}

